(function () {
  if (window.__qitechFormnextTicketsBound) return;
  window.__qitechFormnextTicketsBound = true;

  const TICKET_MAX = 3;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function ticketMax(root) {
    const value = Number(root && root.getAttribute('data-ticket-max'));
    return Number.isFinite(value) && value > 0 ? Math.floor(value) : TICKET_MAX;
  }

  function closestProductForm(root) {
    return root.closest('product-form');
  }

  function productInfoFor(root) {
    return (root && root.closest('product-info')) || document.querySelector('product-info[data-formnext-ticket]');
  }

  function quantityInputFor(root) {
    const productInfo = productInfoFor(root);
    if (productInfo) {
      const marked = productInfo.querySelector('[data-formnext-quantity]');
      if (marked) return marked;
      const named = productInfo.querySelector('input.quantity__input[name="quantity"]');
      if (named) return named;
    }

    const productForm = closestProductForm(root);
    const form = productForm && productForm.querySelector('form');
    if (form && form.elements && form.elements.namedItem) {
      const named = form.elements.namedItem('quantity');
      if (named && named.nodeType === 1) return named;
      if (named && named.length) return named[0];
    }
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function applyTicketCap(root) {
    const input = quantityInputFor(root);
    if (!input) return 1;

    const max = ticketMax(root);
    input.max = String(max);
    input.setAttribute('data-max', String(max));

    const parsed = Number(input.value);
    const value = Number.isFinite(parsed) && parsed > 0 ? Math.min(max, Math.floor(parsed)) : 1;
    if (String(input.value) !== String(value)) input.value = String(value);

    const qtyEl = input.closest('quantity-input');
    if (qtyEl && typeof qtyEl.validateQtyRules === 'function') qtyEl.validateQtyRules();

    return value;
  }

  function liveFields(root) {
    const fieldsWrap = root.querySelector('[data-formnext-fields]');
    if (!fieldsWrap) return [];
    return Array.from(fieldsWrap.children).filter(function (el) {
      return el.hasAttribute && el.hasAttribute('data-formnext-field');
    });
  }

  function labelFor(root, index, total) {
    const one = root.getAttribute('data-label-one') || '';
    const many = root.getAttribute('data-label-many') || '';
    if (total <= 1) return one;
    return many.replace(/__N__/g, String(index));
  }

  function syncFields(root) {
    const fieldsWrap = root.querySelector('[data-formnext-fields]');
    const prototype = root.querySelector('[data-formnext-prototype] [data-formnext-field]');
    if (!fieldsWrap || !prototype) return;

    const total = applyTicketCap(root);
    let fields = liveFields(root);

    while (fields.length < total) {
      const field = prototype.cloneNode(true);
      fieldsWrap.appendChild(field);
      fields = liveFields(root);
    }

    while (fields.length > total) {
      fields.pop().remove();
      fields = liveFields(root);
    }

    const propertyName = root.getAttribute('data-property-name');
    fields.forEach(function (field, index) {
      const input = field.querySelector('[data-formnext-email]');
      const label = field.querySelector('[data-formnext-label]');
      const id = 'Formnext-email-' + root.id + '-' + (index + 1);
      const text = labelFor(root, index + 1, total);
      input.id = id;
      label.setAttribute('for', id);
      label.textContent = text;
      input.setAttribute('placeholder', text);
      if (index === 0 && propertyName) {
        input.setAttribute('name', 'properties[' + propertyName + ']');
      } else {
        input.removeAttribute('name');
      }
    });
  }

  function collectEmails(root) {
    return liveFields(root).map(function (field) {
      const input = field.querySelector('[data-formnext-email]');
      return input ? (input.value || '').trim() : '';
    });
  }

  function normalizeEmail(value) {
    return value.toLowerCase();
  }

  function validate(root) {
    const emails = collectEmails(root);
    const required = root.getAttribute('data-error-required') || '';
    const invalid = root.getAttribute('data-error-invalid') || '';
    const duplicate = root.getAttribute('data-error-duplicate') || '';
    const seen = {};

    for (let i = 0; i < emails.length; i += 1) {
      if (!emails[i]) return { message: required, index: i };
      if (!emailPattern.test(emails[i])) return { message: invalid, index: i };

      const key = normalizeEmail(emails[i]);
      if (seen[key]) return { message: duplicate, index: i };
      seen[key] = true;
    }
    return { message: '', index: -1 };
  }

  function showFormError(productForm, message) {
    if (!productForm || typeof productForm.handleErrorMessage !== 'function') {
      window.alert(message);
      return;
    }
    productForm.handleErrorMessage(message);
  }

  function addTickets(productForm, root, evt) {
    const form = productForm.querySelector('form');
    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput && variantInput.value;
    const emails = collectEmails(root);
    const propertyName = root.getAttribute('data-property-name');
    const cart = productForm.cart;
    const items = emails.map(function (email) {
      const properties = {};
      properties[propertyName] = email;
      return { id: Number(variantId), quantity: 1, properties: properties };
    });

    const body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(document.activeElement);
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          showFormError(productForm, response.description || response.message || '');
          productForm.error = true;
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        productForm.error = false;
        productForm.handleErrorMessage();
        if (window.CartPerformance) {
          window.CartPerformance.measure('add:paint-updated-sections', function () {
            cart.renderContents(response);
          });
        } else {
          cart.renderContents(response);
        }
        syncFields(root);
      })
      .catch(function (error) {
        console.error(error);
        productForm.error = true;
      })
      .finally(function () {
        productForm.submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!productForm.error) productForm.submitButton.removeAttribute('aria-disabled');
        const spinner = productForm.querySelector('.loading__spinner');
        if (spinner) spinner.classList.add('hidden');
        if (window.CartPerformance) {
          window.CartPerformance.measureFromEvent('add:user-action', evt);
        }
      });
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    const root = form.querySelector('[data-formnext-tickets]');
    if (!root) return;

    const productForm = closestProductForm(root);
    if (!productForm) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (productForm.submitButton.getAttribute('aria-disabled') === 'true') return;

    syncFields(root);
    const error = validate(root);
    if (error.message) {
      showFormError(productForm, error.message);
      const fields = liveFields(root);
      const badField = fields[error.index] || fields[0];
      const badInput = badField && badField.querySelector('[data-formnext-email]');
      if (badInput) badInput.focus();
      return;
    }

    productForm.handleErrorMessage();
    productForm.submitButton.setAttribute('aria-disabled', true);
    productForm.submitButton.classList.add('loading');
    const spinner = productForm.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    addTickets(productForm, root, event);
  }

  function rootFromQuantityNode(node) {
    const productInfo = node && node.closest('product-info');
    const scope = productInfo || document;
    return scope.querySelector('[data-formnext-tickets]');
  }

  function onQuantityEvent(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.name !== 'quantity' && !input.hasAttribute('data-formnext-quantity')) return;
    const root = rootFromQuantityNode(input) || document.querySelector('[data-formnext-tickets]');
    if (root) syncFields(root);
  }

  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onQuantityEvent);
  document.addEventListener('input', onQuantityEvent);

  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.quantityUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.quantityUpdate, function () {
      document.querySelectorAll('[data-formnext-tickets]').forEach(syncFields);
    });
  }

  function scan(node) {
    (node || document).querySelectorAll('[data-formnext-tickets]').forEach(function (root) {
      if (!root.id) root.id = 'formnext-' + Math.random().toString(36).slice(2, 9);
      syncFields(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
